import { OrsServiceExceptionRepository } from 'modules/contractedService/domain/ors/exception/repository/OrsServiceExceptionRepository'
import { defaultOptionsFetch, FetchAPI, FetchOptions, IAuthData } from 'ufinet-web-functions'

const url = `${process.env.REACT_APP_URL_BACK_GSE_WSO2}api/services/contracted/ors/exception`

export const HttpOrsServiceExceptionRepository = (authData: IAuthData): OrsServiceExceptionRepository => {
	const fetchOptions: FetchOptions = {
		...defaultOptionsFetch,
		authenticationData: authData,
		sendApiKey: true,
		apiKey: process.env.REACT_APP_API_KEY_WSO2
	}

	return {
		findAllOfUser: async (options) =>
			await FetchAPI.get(url, {
				...fetchOptions,
				...options,
			}),
		findAllOfUserByStatus: async (status, options) =>
			await FetchAPI.get_params(url, status, {
				...fetchOptions,
				...options
			}),
		findTotal: async (options) =>
			await FetchAPI.get(url + '/total', {
				...fetchOptions,
				...options
			}),
		updateStates: async (request, options) => await FetchAPI.patch(url, request, { ...fetchOptions, ...options }),
	}
}
